import React, { useState, useEffect } from "react";
import { Line } from "@ant-design/plots";
import styled from "styled-components";
import { asNumber } from 'utils/text'

export default function MultiLineChart(props) {
  const useWindowDimensions = () => {
    const hasWindow = typeof window !== "undefined";

    function getWindowDimensions() {
      const width = hasWindow ? window.innerWidth : null;
      return {
        width,
      };
    }

    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );

    useEffect(() => {
      if (hasWindow) {
        function handleResize() {
          setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }
    }, [hasWindow]);

    return windowDimensions;
  };

  const { width } = useWindowDimensions();

  const config = {
    data: props.data,
    xField: "date",
    yField: "value",
    yAxis: {
      label: {
        formatter: (v) => `${asNumber(v)}`,
      },
    },
    xAxis: {
      label: {
        formatter: (v) => v,
      },
    },
    height: 290,
    smooth: true,
    legend: {
      position: "top-left",
      offsetX: width < 600 ? 0 : 110,
      offsetY: -8,
      marker: {
        spacing: 2,
      },
    },
    seriesField: "type",
    color: ({ type }) => {
      return type === "Personal Sales" ? "#FF2727" : "#0ABAB5";
    },
    lineStyle: ({ type }) => {
      return {
        opacity: 0.5,
      };
    },
  };
  return (
    <Wrapper>
      <Line {...config} />
    </Wrapper>
  );
}
export const Wrapper = styled.div``;
